import _ from 'lodash';
import * as treeUtils from '../components/common/DynamicTree/DynamicTreeUtils';
import * as types from '../actions/actionTypes';
import initialState from './initialState';
import {
  INSIGHT_360_DEFAULT_DISPLAY_OPTION,
  VERTICAL_PERCENT_FILTER_VALUE,
  INSIGHT360_EXPLORE,
  INSIGHT360_PERSONA_CREATOR,
  SECTION_SORT_BY_PROFILE,
} from '../constants';
import { findObjectIndexInArray, getHighestIndexOrReachObject } from '../util/CommonUtils';


/* const initialState = {
  demographics: [],
  insight360PersonaFilter: ['', '', ''],
  attitudes: [],
  insight360AttitudeAgreeChoice: ANY_AGREE,
  insight360PersonaSample: [],
  insight360PersonaWeighted: [],
  insight360ReportsDictionaryTree: {},
  insights360Reports: [],
  insight360PersonaExpression: [],
  insight360PersonaExpressionID: [],
  insight360ExplorerDefId: [],
  insight360PersonaLabel: [],
  inight360VerticalPercent: VERTICAL_PERCENT_FILTER_VALUE,
  insights360ReportSortInfo: {},
  media: [],
  brands: [],
  profiles: [],
  selectedCategory: {},
  selectedFilters: {
    brands: [],
    media: [],
  },
  definitionTree: [],
  insight360VariableSelection: [],
  insight360PersonaFixedHeaderChoice: false,
  error: {},
  personaCreator: {
    insight360AttitudeAgreeChoice: ANY_AGREE,
    inight360VerticalPercent: VERTICAL_PERCENT_FILTER_VALUE,
    clusterSegments: {
      segmentCount: 3,
      attitudesList: [],
      clusterStatExpressions: [],
      selectedExpressionObject: [],
      defaultExpression: [],
      defaultExpressionObject: [],
      defaultAttitudinalTemplate: [],
      selectedAttitudinalTemplate: {},
    },
    multiClusterSegments: [],
    segments: [],
    segmentsScreen: false,
    pcWelcomePopup: true,
    selectedFilters: {
      brands: [],
      media: [],
    },
  },
}; */

const generateObject = (obj, field, value) => {
  let result = { ...obj };
  if (!_.isEmpty(field)) {
    result[field] = value;
  } else {
    result = value;
  }
  return result;
};

export default function (state = initialState.insight360, action) {
  switch (action.type) {
    case types.SHOW_BRAND_INSIGHT360_PERSONAS_DEMOGRAPHICS: {
      const demographics = [];
      action.payload.data.forEach(element => {
        const demograph = {};
        demograph.label =
          element.headers !== undefined && element.headers[1] !== undefined
            ? element.headers[1].label
            : '';
        const displayOptions = element.displayOptions;
        demograph.detailGroups = [];
        _.forEach(element.detailGroups, (details, key) => {
          if (key !== 'General') {
            const detail = {};
            detail.name = key;
            let displayOption =
              displayOptions[key] !== undefined ? displayOptions[key] : 'index';
            displayOption = displayOption === 'percent' ? 'pct' : displayOption;
            const reverseList = _.reverse(
              _.sortBy(details, [
                function (o) {
                  if (
                    o.value !== undefined &&
                    o.value[displayOption] !== undefined
                  ) {
                    if (displayOption === 'pct') {
                      return _.toNumber(
                        o.value[displayOption].replace('%', ''),
                      );
                    }
                    return o.value[displayOption];
                  }
                  return -1;
                },
              ]),
            );
            detail.data = reverseList[0];
            demograph.detailGroups.push(detail);
          }
        });
        demographics.push(demograph);
      });
      if (
        action.payload.isPersonaCreator !== undefined &&
        action.payload.isPersonaCreator
      ) {
        return {
          ...state,
          personaCreator: {
            ...state.personaCreator,
            demographics,
          },
        };
      }
      return {
        ...state,
        demographics:
          (action.payload.isBaseCall !== undefined &&
          action.payload.isBaseCall === true) || (action.payload.isSectionSort !== undefined
            && action.payload.isSectionSort === true)
            ? demographics
            : [...state.demographics, ...demographics],
      };
    }
    case types.SHOW_BRAND_INSIGHT360_PERSONAS_ATTITUDES: {
      const _attitudes = [];
      const detailGroupsKey = [];
      action.payload.data.forEach(element => {
        const attitude = {};
        attitude.label =
          element.headers !== undefined && element.headers[1] !== undefined
            ? element.headers[1].label
            : '';
        const displayOptions = element.displayOptions;
        attitude.attitudeGroups = [];
        _.forEach(element.detailGroups, (details, attitudeKey) => {
          const detailGroups = [];
         // detailGroupsKey.push(_.toUpper(attitudeKey));
          detailGroupsKey.push(attitudeKey);
          _.forEach(details, (data, key) => {
            const attitudeDetail = {};
            let displayOption =
              displayOptions[key] !== undefined && displayOptions[key].sortBy
                ? displayOptions[key].sortBy
                : 'index';
            const icon =
              displayOptions[key] !== undefined && displayOptions[key].icon
                ? displayOptions[key].icon
                : key;
            displayOption = displayOption === 'percent' ? 'pct' : displayOption;
            const reverseList = _.reverse(
              _.sortBy(data, [
                function (o) {
                  if (
                    o.value !== undefined &&
                    o.value[displayOption] !== undefined
                  ) {
                    if (displayOption === 'pct') {
                      return _.toNumber(
                        o.value[displayOption].replace('%', ''),
                      );
                    }
                    return o.value[displayOption];
                  }
                  return -1;
                },
              ]),
            );
            attitudeDetail.categoryName = key;
            attitudeDetail.icon = icon;
            attitudeDetail.data = reverseList[0];
            detailGroups.push(attitudeDetail);
          });
          const attitudeGroup = {};
         // attitudeGroup[_.toUpper(attitudeKey)] = detailGroups;
          attitudeGroup[attitudeKey] = detailGroups;
          attitude.attitudeGroups.push(attitudeGroup);
        });
        _attitudes.push(attitude);
      });
      // updating default value for choice slider
     // this.props.updateAttitudeAgreeChoice(getOptions(_attitudes[0]));
      if (
        action.payload.isPersonaCreator !== undefined &&
        action.payload.isPersonaCreator
      ) {
        return {
          ...state,
          personaCreator: { ...state.personaCreator,
            attitudes: _attitudes,
            insight360AttitudeAgreeChoice:
            state.personaCreator.insight360AttitudeAgreeChoice === '' ||
            detailGroupsKey.indexOf(state.personaCreator.insight360AttitudeAgreeChoice) === -1
            ? detailGroupsKey[0]
            : state.personaCreator.insight360AttitudeAgreeChoice,
          },
        };
      }
      return {
        ...state,
        insight360AttitudeAgreeChoice:
        state.insight360AttitudeAgreeChoice === '' ||
        detailGroupsKey.indexOf(state.insight360AttitudeAgreeChoice) === -1
        ? detailGroupsKey[0]
        : state.insight360AttitudeAgreeChoice,
        attitudes:
         (action.payload.isBaseCall !== undefined &&
          action.payload.isBaseCall === true) || (action.payload.isSectionSort !== undefined
            && action.payload.isSectionSort === true)
            ? _attitudes
            : [...state.attitudes, ..._attitudes],
      };
    }
    case types.SHOW_BRAND_INSIGHT360_PERSONAS_BRANDS: {
      const brands = [];
      action.payload.data.forEach(element => {
        const brand = {};
        brand.label =
          element.headers !== undefined && element.headers[1] !== undefined
            ? element.headers[1].label
            : '';
        brand.brandList = [];
        element.detail.forEach(elm => {
          brand.brandList.push(elm);
        });
        brands.push(brand);
      });
      if (
        action.payload.isPersonaCreator !== undefined &&
        action.payload.isPersonaCreator
      ) {
        return {
          ...state,
          personaCreator: { ...state.personaCreator, brands },
        };
      }
      return {
        ...state,
        brands:
          (action.payload.isBaseCall !== undefined &&
          action.payload.isBaseCall === true) || (action.payload.isSectionSort !== undefined
            && action.payload.isSectionSort === true)
            ? brands
            : [...state.brands, ...brands],
      };
    }

    // profile brands section..
    case types.SHOW_INSIGHT360_PROFILE_PERSONAS_BRANDS: {
      const profileBrands = [];
      action.payload.data.forEach(element => {
        const brand = {};
        brand.label =
          element.headers !== undefined && element.headers[1] !== undefined
            ? element.headers[1].label
            : '';
        brand.brandList = [];
        element.detail.forEach(elm => {
          brand.brandList.push(elm);
        });
        profileBrands.push(brand);
      });
      if (
        action.payload.isPersonaCreator !== undefined &&
        action.payload.isPersonaCreator
      ) {
        return {
          ...state,
          personaCreator: { ...state.personaCreator, profileBrands },
        };
      }
      return {
        ...state,
        profileBrands:
          (action.payload.isBaseCall !== undefined &&
          action.payload.isBaseCall === true) || (action.payload.isSectionSort !== undefined
            && action.payload.isSectionSort === true)
            ? profileBrands
            : [...state.profileBrands, ...profileBrands],
      };
    }
    // / profile brand top5 section end

    // start apply filter profile brand sections...
    case types.UPDATE_INSIGHT360_PROFILE_BRANDS: {
      const brand = {};
      brand.brandList = [];
      brand.label =
        action.payload[0].headers != undefined &&
        action.payload[0].headers[1] !== undefined
          ? action.payload[0].headers[1].label
          : '';
      action.payload[0].detail.forEach(elm => {
        brand.brandList.push(elm);
      });

      const updatedItems = state.profileBrands.map((item, index) => {
        if (index === action.payload[1].index) {
          return brand;
        }
        return item;
      });

      return {
        ...state,
        profileBrands: updatedItems,
      };
    }
      // end  filter profile brand sections...

       // profile top 5 media section..
    case types.SHOW_INSIGHT360_PROFILE_MEDIA: {
      const profileMedia = [];
      action.payload.data.forEach(element => {
        const brand = {};
        brand.label =
          element.headers !== undefined && element.headers[1] !== undefined
            ? element.headers[1].label
            : '';
        brand.brandList = [];
        element.detail.forEach(elm => {
          brand.brandList.push(elm);
        });
        profileMedia.push(brand);
      });
      if (
        action.payload.isPersonaCreator !== undefined &&
        action.payload.isPersonaCreator
      ) {
        return {
          ...state,
          personaCreator: { ...state.personaCreator, profileMedia },
        };
      }
      return {
        ...state,
        profileMedia:
          (action.payload.isBaseCall !== undefined &&
          action.payload.isBaseCall === true) || (action.payload.isSectionSort !== undefined
            && action.payload.isSectionSort === true)
            ? profileMedia
            : [...state.profileMedia, ...profileMedia],
      };
    }
    // / profile media top5 section end

     // start apply filter profile media sections...
    case types.UPDATE_INSIGHT360_PROFILE_MEDIA: {
      const brand = {};
      brand.brandList = [];
      brand.label =
        action.payload[0].headers !== undefined &&
        action.payload[0].headers[1] !== undefined
          ? action.payload[0].headers[1].label
          : '';
      action.payload[0].detail.forEach(elm => {
        brand.brandList.push(elm);
      });

      const updatedItems = state.profileMedia.map((item, index) => {
        if (index === action.payload[1].index) {
          return brand;
        }
        return item;
      });

      return {
        ...state,
        profileMedia: updatedItems,
      };
    }
      // end  filter profile media sections...

    case types.UPDATE_BRAND_INSIGHT360_BRANDS: {
      const brand = {};
      brand.brandList = [];
      brand.label =
        action.payload[0].headers != undefined &&
        action.payload[0].headers[1] !== undefined
          ? action.payload[0].headers[1].label
          : '';
      action.payload[0].detail.forEach(elm => {
        brand.brandList.push(elm);
      });

      const updatedItems = state.brands.map((item, index) => {
        if (index === action.payload[1].index) {
          return brand;
        }
        return item;
      });

      return {
        ...state,
        brands: updatedItems,
      };
    }

    case types.SHOW_INSIGHT360_PERSONAS_PROFILES: {
      const profiles = [];
      action.payload.data.forEach(element => {
        const data = element;
        const sectionData = {};
        _.forEach(data.displayOptions, (value, key) => {
          let profileData = [];
          if (data.detailGroups[key] === undefined || data.detailGroups[key].length === 0) {
            profileData = {
              label: 'N/A',
              value: {
                pct: 'N/A',
                icon: 'none.png',
                index: 'N/A',
                sample: 'N/A',
                weighted: 'N/A',
              },
            };
            profileData.value.icon = data.iconDetails[key];
            sectionData[key] = profileData;
          } else {
            profileData = getHighestIndexOrReachObject(data.detailGroups[key], value);
            sectionData[key] = profileData[0];
          }
          // sectionData.push(profile);
        });
        profiles.push(sectionData);
      });
      if (
        action.payload.isPersonaCreator !== undefined &&
        action.payload.isPersonaCreator
      ) {
        return {
          ...state,
          personaCreator: { ...state.personaCreator, profiles },
        };
      }
      return {
        ...state,
        profiles:
          (action.payload.isBaseCall !== undefined &&
          action.payload.isBaseCall === true) || (action.payload.isSectionSort !== undefined
             && action.payload.isSectionSort === true)
            ? profiles
            : [...state.profiles, ...profiles],
      };
    }


    // case types.SHOW_INSIGHT360_PERSONAS_PROFILES: {
    //   const profiles = [];
    //   action.payload.data.forEach(element => {
    //     const profile = {};
    //     let displayOptions = element.displayOptions[PROFILE_ATTITUDE_GENERAL];
    //     // defaulting for negative scenerios
    //     if (displayOptions === undefined) {
    //       displayOptions = 'index';
    //     }
    //     // defaulting for negative scenerios
    //     const attitudeGeneralList = _.reverse(
    //       _.sortBy(element.detailGroups[PROFILE_ATTITUDE_GENERAL], [
    //         function (o) {
    //           if (
    //             o.value !== undefined &&
    //             o.value[displayOptions] !== undefined
    //           ) {
    //             return o.value[displayOptions];
    //           }
    //           return -1;
    //         },
    //       ]),
    //     );
    //     profile.personality = attitudeGeneralList[0];

    //     // defaulting for negative scenerios
    //     if (profile.personality === undefined) {
    //       profile.personality = {
    //         label: 'N/A',
    //         value: {
    //           pct: 'N/A',
    //           icon: '360-generic-profile-icon.png',
    //           index: 'N/A',
    //           sample: 'N/A',
    //           weighted: 'N/A',
    //         },
    //       };
    //     }
    //     // defaulting for negative scenerios

    //     displayOptions = element.displayOptions[PROFILE_SELF_CONCEPTS];
    //     // defaulting for negative scenerios
    //     if (displayOptions === undefined) {
    //       displayOptions = 'index';
    //     }
    //     // defaulting for negative scenerios
    //     const selfConceptsList = _.reverse(
    //       _.sortBy(element.detailGroups[PROFILE_SELF_CONCEPTS], [
    //         function (o) {
    //           if (
    //             o.value !== undefined &&
    //             o.value[displayOptions] !== undefined
    //           ) {
    //             return o.value[displayOptions];
    //           }
    //           return -1;
    //         },
    //       ]),
    //     );
    //     profile.selfConcepts = selfConceptsList[0];
    //     // defaulting for negative scenerios
    //     if (profile.selfConcepts === undefined) {
    //       profile.selfConcepts = {
    //         label: 'N/A',
    //         value: {
    //           pct: 'N/A',
    //           index: 'N/A',
    //           sample: 'N/A',
    //           weighted: 'N/A',
    //         },
    //       };
    //     }
    //     // defaulting for negative scenerios

    //     displayOptions =
    //       element.displayOptions[PROFILE_FINANCIAL_OUTLOOK_FUTURE];
    //     // defaulting for negative scenerios
    //     if (displayOptions === undefined) {
    //       displayOptions = 'index';
    //     }
    //     // defaulting for negative scenerios
    //     const futureFinancialList = _.reverse(
    //       _.sortBy(element.detailGroups[PROFILE_FINANCIAL_OUTLOOK_FUTURE], [
    //         function (o) {
    //           if (
    //             o.value !== undefined &&
    //             o.value[displayOptions] !== undefined
    //           ) {
    //             return o.value[displayOptions];
    //           }
    //           return -1;
    //         },
    //       ]),
    //     );
    //     profile.futureFinancial = futureFinancialList[0];
    //     // defaulting for negative scenerios
    //     if (profile.futureFinancial === undefined) {
    //       profile.futureFinancial = {
    //         label: 'N/A',
    //         value: {
    //           pct: 'N/A',
    //           icon: 'none.png',
    //           index: 'N/A',
    //           sample: 'N/A',
    //           weighted: 'N/A',
    //         },
    //       };
    //     }
    //     // defaulting for negative scenerios

    //     displayOptions = element.displayOptions[PROFILE_FINANCIAL_OUTLOOK_PAST];
    //     // defaulting for negative scenerios
    //     if (displayOptions === undefined) {
    //       displayOptions = 'index';
    //     }
    //     // defaulting for negative scenerios
    //     const pastFinancialList = _.reverse(
    //       _.sortBy(element.detailGroups[PROFILE_FINANCIAL_OUTLOOK_PAST], [
    //         function (o) {
    //           if (
    //             o.value !== undefined &&
    //             o.value[displayOptions] !== undefined
    //           ) {
    //             return o.value[displayOptions];
    //           }
    //           return -1;
    //         },
    //       ]),
    //     );
    //     profile.pastFinancial = pastFinancialList[0];
    //     // defaulting for negative scenerios
    //     if (profile.pastFinancial === undefined) {
    //       profile.pastFinancial = {
    //         label: 'N/A',
    //         value: {
    //           pct: 'N/A',
    //           icon: 'none.png',
    //           index: 'N/A',
    //           sample: 'N/A',
    //           weighted: 'N/A',
    //         },
    //       };
    //     }
    //     // defaulting for negative scenerios

    //     displayOptions =
    //       element.displayOptions[PROFILE_PURCHASE_BIG_TICKET_ITEM];
    //     // defaulting for negative scenerios
    //     if (displayOptions === undefined) {
    //       displayOptions = 'index';
    //     }
    //     // defaulting for negative scenerios
    //     const bigTicketList = _.reverse(
    //       _.sortBy(element.detailGroups[PROFILE_PURCHASE_BIG_TICKET_ITEM], [
    //         function (o) {
    //           if (
    //             o.value !== undefined &&
    //             o.value[displayOptions] !== undefined
    //           ) {
    //             return o.value[displayOptions];
    //           }
    //           return -1;
    //         },
    //       ]),
    //     );
    //     profile.bigTicketItem = bigTicketList[0];
    //     // defaulting for negative scenerios
    //     if (profile.bigTicketItem === undefined) {
    //       profile.bigTicketItem = {
    //         label: 'N/A',
    //         value: {
    //           pct: 'N/A',
    //           icon: 'none.png',
    //           index: 'N/A',
    //           sample: 'N/A',
    //           weighted: 'N/A',
    //         },
    //       };
    //     }
    //     // defaulting for negative scenerios

    //     displayOptions =
    //       element.displayOptions[PROFILE_PURCHASE_MEDIUM_TICKET_ITEM];
    //     // defaulting for negative scenerios
    //     if (displayOptions === undefined) {
    //       displayOptions = 'index';
    //     }
    //     // defaulting for negative scenerios
    //     const mediumTicketList = _.reverse(
    //       _.sortBy(element.detailGroups[PROFILE_PURCHASE_MEDIUM_TICKET_ITEM], [
    //         function (o) {
    //           if (
    //             o.value !== undefined &&
    //             o.value[displayOptions] !== undefined
    //           ) {
    //             return o.value[displayOptions];
    //           }
    //           return -1;
    //         },
    //       ]),
    //     );
    //     profile.mediumTicket = mediumTicketList[0];
    //     // defaulting for negative scenerios
    //     if (profile.mediumTicket === undefined) {
    //       profile.mediumTicket = {
    //         label: 'N/A',
    //         value: {
    //           pct: 'N/A',
    //           icon: 'none.png',
    //           index: 'N/A',
    //           sample: 'N/A',
    //           weighted: 'N/A',
    //         },
    //       };
    //     }
    //     // defaulting for negative scenerios

    //     displayOptions = element.displayOptions[PROFILE_CONSUMER_CONFIDENCE];
    //     // defaulting for negative scenerios
    //     if (displayOptions === undefined) {
    //       displayOptions = 'index';
    //     }
    //     // defaulting for negative scenerios
    //     const consumerConfidenceList = _.reverse(
    //       _.sortBy(element.detailGroups[PROFILE_CONSUMER_CONFIDENCE], [
    //         function (o) {
    //           if (
    //             o.value !== undefined &&
    //             o.value[displayOptions] !== undefined
    //           ) {
    //             return o.value[displayOptions];
    //           }
    //           return -1;
    //         },
    //       ]),
    //     );
    //     profile.consumerConfidence = consumerConfidenceList[0];
    //     // defaulting for negative scenerios
    //     if (profile.consumerConfidence === undefined) {
    //       profile.consumerConfidence = {
    //         label: 'N/A',
    //         value: {
    //           pct: 'N/A',
    //           icon: 'none.png',
    //           index: 'N/A',
    //           sample: 'N/A',
    //           weighted: 'N/A',
    //         },
    //       };
    //     }
    //     // defaulting for negative scenerios

    //     displayOptions = element.displayOptions[PROFILE_PURCHASE_PROPENSITY];
    //     // defaulting for negative scenerios
    //     if (displayOptions === undefined) {
    //       displayOptions = 'index';
    //     }
    //     // defaulting for negative scenerios
    //     const propensityList = _.reverse(
    //       _.sortBy(element.detailGroups[PROFILE_PURCHASE_PROPENSITY], [
    //         function (o) {
    //           if (
    //             o.value !== undefined &&
    //             o.value[displayOptions] !== undefined
    //           ) {
    //             return o.value[displayOptions];
    //           }
    //           return -1;
    //         },
    //       ]),
    //     );
    //     profile.propensity = propensityList[0];
    //     // defaulting for negative scenerios
    //     if (profile.propensity === undefined) {
    //       profile.propensity = {
    //         label: 'N/A',
    //         value: {
    //           pct: 'N/A',
    //           icon: 'none.png',
    //           index: 'N/A',
    //           sample: 'N/A',
    //           weighted: 'N/A',
    //         },
    //       };
    //     }
    //     // defaulting for negative scenerios

    //     profiles.push(profile);
    //   });

    //   if (
    //     action.payload.isPersonaCreator !== undefined &&
    //     action.payload.isPersonaCreator
    //   ) {
    //     return {
    //       ...state,
    //       personaCreator: { ...state.personaCreator, profiles },
    //     };
    //   }
    //   return {
    //     ...state,
    //     profiles:
    //       action.payload.isBaseCall !== undefined &&
    //       action.payload.isBaseCall === true
    //         ? profiles
    //         : [...state.profiles, ...profiles],
    //   };
    // }

    case types.UPDATE_BRAND_INSIGHT360_PROFILES: {
       // defaulting for negative scenerios
      const data = action.payload[0];
      const sectionData = {};
      _.forEach(data.displayOptions, (value, key) => {
        let profileData = [];
        if (data.detailGroups[key] === undefined || data.detailGroups[key].length === 0) {
          profileData = {
            label: 'N/A',
            value: {
              pct: 'N/A',
              icon: 'none.png',
              index: 'N/A',
              sample: 'N/A',
              weighted: 'N/A',
            },
          };
          profileData.value.icon = data.iconDetails[key];
          sectionData[key] = profileData;
        } else {
          profileData = getHighestIndexOrReachObject(data.detailGroups[key], value);
          sectionData[key] = profileData[0];
        }
      });

      const updatedItems = state.profiles.map((item, index) => {
        if (index === action.payload[1].index) {
          return sectionData;
        }
        return item;
      });

      return {
        ...state,
        profiles: updatedItems,
      };
    }
    case types.GET_360_DEMOGRAPHICS_FILTER_OPTIONS: {
      return {
        ...state,
        insight360DemographicsFilterOptions: action.payload,
      };
    }
    case types.SAVE_BRAND_INSIGHT360_HEADER_INFO: {
      return {
        ...state,
        insight360PersonaExpression:
          state.insight360PersonaExpression === undefined ||
          state.insight360PersonaExpression.length === 0
            ? [action.payload.expressions[0]]
            : [
              ...state.insight360PersonaExpression,
              action.payload.expressions[0],
            ],
        insight360PersonaLabel:
          state.insight360PersonaLabel === undefined ||
          state.insight360PersonaLabel.length === 0
            ? [action.payload.label]
            : [...state.insight360PersonaLabel, action.payload.label],
        insight360PersonaPct:
          state.insight360PersonaPct === undefined ||
          state.insight360PersonaPct.length === 0
            ? [action.payload.pct]
            : [...state.insight360PersonaPct, action.payload.pct],
        insight360PersonaWeighted:
          state.insight360PersonaWeighted === undefined ||
          state.insight360PersonaWeighted.length === 0
            ? [action.payload.weighted]
            : [...state.insight360PersonaWeighted, action.payload.weighted],
        insight360PersonaSample:
          state.insight360PersonaSample === undefined ||
          state.insight360PersonaSample.length === 0
            ? [action.payload.sample]
            : [...state.insight360PersonaSample, action.payload.sample],
        insight360PersonaExpressionID:
          state.insight360PersonaExpressionID === undefined ||
          state.insight360PersonaExpressionID.length === 0
            ? [action.payload.expressionsId]
            : [
              ...state.insight360PersonaExpressionID,
              action.payload.expressionsId,
            ],
        insight360ExplorerDefId:
          state.insight360ExplorerDefId === undefined ||
          state.insight360ExplorerDefId.length === 0
            ? [action.payload.definationId]
            : [...state.insight360ExplorerDefId, action.payload.definationId],
      };
    }
    case types.INVALID_PERSONA_SELECTED: {
      const error = {
        key: 'Invalid Persona',
        msg: action.payload,
      };

      return {
        ...state,
        error,
      };
    }
    case types.UPDATE_BRAND_INSIGHT360_HEADERINFO: {
      if (action.payload.index !== undefined) {
        const updatedPersonaPct = state.insight360PersonaPct.map(
          (item, index) => {
            if (index === action.payload.index) {
              return action.payload.pct;
            }
            return item;
          },
        );
        const updatedPersonaWeighted = state.insight360PersonaWeighted.map(
          (item, index) => {
            if (index === action.payload.index) {
              return action.payload.weighted;
            }
            return item;
          },
        );
        const updatedPersonaSample = state.insight360PersonaSample.map(
          (item, index) => {
            if (index === action.payload.index) {
              return action.payload.sample;
            }
            return item;
          },
        );

        return {
          ...state,
          insight360PersonaPct: updatedPersonaPct,
          insight360PersonaWeighted: updatedPersonaWeighted,
          insight360PersonaSample: updatedPersonaSample,
        };
      } 
        const updatedPersonaPct = state.insight360PersonaPct.map(
          (item, index) => {
            return action.payload[index].headers[1].pct;
          },
        );
        const updatedPersonaWeighted = state.insight360PersonaWeighted.map(
          (item, index) => {
            return action.payload[index].headers[1].weighted;
          },
        );
        const updatedPersonaSample = state.insight360PersonaSample.map(
          (item, index) => {
            return action.payload[index].headers[1].sample;
          },
        );

        return {
          ...state,
          insight360PersonaPct: updatedPersonaPct,
          insight360PersonaWeighted: updatedPersonaWeighted,
          insight360PersonaSample: updatedPersonaSample,
        };
      
    }
    case types.SAVE_BRAND_INSIGHT360_BASE_INFO: {
      return {
        ...state,
        insight360Base: action.payload,
      };
    }
    case types.SAVE_BRAND_INSIGHT360_PERSONA_FILTER: {
      if (
        state.insight360PersonaFilter !== undefined &&
        state.insight360PersonaFilter.length > 0
      ) {
        const updatedItems = state.insight360PersonaFilter.map(
          (item, index) => {
            if (index === action.payload.index) {
              return action.payload.filter;
            }
            return item;
          },
        );

        updatedItems.filterIndex = action.payload.index;
        return {
          ...state,
          insight360PersonaFilter: updatedItems,
        };
      }
      return {
        ...state,
        insight360PersonaFilter: [action.payload.filter],
      };
    }
    case types.UPDATE_BRAND_INSIGHT360_DEMOGRAPHICS_PERSONAS: {
      const demograph = {};
      demograph.label =
        action.payload[0].headers !== undefined &&
        action.payload[0].headers[1] !== undefined
          ? action.payload[0].headers[1].label
          : '';
      const displayOptions = action.payload[0].displayOptions;
      demograph.detailGroups = [];
      _.forEach(action.payload[0].detailGroups, (details, key) => {
        if (key !== 'General') {
          const detail = {};
          detail.name = key;
          let displayOption =
            displayOptions[key] !== undefined ? displayOptions[key] : 'index';
          displayOption = displayOption === 'percent' ? 'pct' : displayOption;
          const reverseList = _.reverse(
            _.sortBy(details, [
              function (o) {
                if (
                  o.value !== undefined &&
                  o.value[displayOption] !== undefined
                ) {
                  if (displayOption === 'pct') {
                    return _.toNumber(o.value[displayOption].replace('%', ''));
                  }
                  return o.value[displayOption];
                }
                return -1;
              },
            ]),
          );
          detail.data = reverseList[0];
          demograph.detailGroups.push(detail);
        }
      });

      const updatedItems = state.demographics.map((item, index) => {
        if (index === action.payload[1].index) {
          return demograph;
        }
        return item;
      });
      return {
        ...state,
        demographics: updatedItems,
      };
    }
    case types.UPDATE_BRAND_INSIGHT360_ATTITUDES_PERSONAS: {
      const attitude = {};
      attitude.label =
        action.payload[0].headers !== undefined &&
        action.payload[0].headers[1] !== undefined
          ? action.payload[0].headers[1].label
          : '';
      const displayOptions = action.payload[0].displayOptions;
      attitude.attitudeGroups = [];
      _.forEach(action.payload[0].detailGroups, (details, attitudeKey) => {
        const detailGroups = [];
        _.forEach(details, (data, key) => {
          const attitudeDetail = {};
          let displayOption =
            displayOptions[key] !== undefined && displayOptions[key].sortBy
              ? displayOptions[key].sortBy
              : 'index';
          const icon =
            displayOptions[key] !== undefined && displayOptions[key].icon
              ? displayOptions[key].icon
              : key;
          displayOption = displayOption === 'percent' ? 'pct' : displayOption;
          const reverseList = _.reverse(
            _.sortBy(data, [
              function (o) {
                if (
                  o.value !== undefined &&
                  o.value[displayOption] !== undefined
                ) {
                  if (displayOption === 'pct') {
                    return _.toNumber(o.value[displayOption].replace('%', ''));
                  }
                  return o.value[displayOption];
                }
                return -1;
              },
            ]),
          );
          attitudeDetail.categoryName = key;
          attitudeDetail.icon = icon;
          attitudeDetail.data = reverseList[0];
          detailGroups.push(attitudeDetail);
        });
        const attitudeGroup = {};
        attitudeGroup[attitudeKey] = detailGroups;
        attitude.attitudeGroups.push(attitudeGroup);
      });

      const updatedItems = state.attitudes.map((item, index) => {
        if (index === action.payload[1].index) {
          return attitude;
        }
        return item;
      });
      return {
        ...state,
        attitudes: updatedItems,
      };
    }
    case types.RESET_ALL_INSIGHT360: {
      const filterArray = ['', '', ''];
      filterArray.filterIndex = -1;
      return {
        ...state,
        demographics: [],
        attitudes: [],
        insight360PersonaExpression: [],
        insight360PersonaLabel: [],
        insight360PersonaSample: [],
        insight360PersonaWeighted: [],
        insight360PersonaPct: [],
        insight360PersonaFilter: filterArray,
        insight360AttitudeAgreeChoice: '',
        brands: [],
        media: [],
        profiles: [],
        profileBrands: [],
        profileMedia: [],
        insight360Base: undefined,
        insights360Reports: [],
        insight360PersonaFixedHeaderChoice: false,
        inight360VerticalPercent: VERTICAL_PERCENT_FILTER_VALUE,
        insights360ReportSortInfo: {},
        selectedCategory: {},
        // set to default user prefrences during reset
        selectedFilters: {
          brands: action.payload.brandFilters,
          media: action.payload.mediaFilters,
        },
        topMediaBrandSelectedFilters: {
          brands: action.payload.brandFilters,
          media: action.payload.mediaFilters,
        },
        sortByIndexAndReach: {
          media: 'index',
          brands: 'index',
          profiles: 'index',
          attitudes: 'index',
          demographics: 'index',
        },
      };
    }

    // MEDIA
    // case types.SHOW_MEDIA_INSIGHT360_PERSONAS_MEDIA:
    case types.SHOW_MEDIA_INSIGHT360_PERSONAS_MEDIA: {
      const _media = [];
      action.payload.data.forEach(element => {
        // media.push(element);
        const mediaData = {};
        mediaData.label =
          element.headers !== undefined && element.headers[1] !== undefined
            ? element.headers[1].label
            : '';
        mediaData.brandList = [];
        element.detail.forEach(elm => {
          mediaData.brandList.push(elm);
        });
        _media.push(mediaData);
      });

      if (
        action.payload.isPersonaCreator !== undefined &&
        action.payload.isPersonaCreator
      ) {
        return {
          ...state,
          personaCreator: { ...state.personaCreator, media: _media },
        };
      } 
        return {
          ...state,
          media:
            (action.payload.isBaseCall !== undefined &&
            action.payload.isBaseCall === true) || (action.payload.isSectionSort !== undefined
              && action.payload.isSectionSort === true)
              ? _media
              : [...state.media, ..._media],
        };
      
    }

    case types.UPDATE_BRAND_INSIGHT360_MEDIA: {
      const mediaData = {};
      mediaData.label =
        action.payload[0].headers !== undefined &&
        action.payload[0].headers[1] !== undefined
          ? action.payload[0].headers[1].label
          : '';
      mediaData.brandList = [];
      action.payload[0].detail.forEach(elm => {
        mediaData.brandList.push(elm);
      });

      const updatedItems = state.media.map((item, index) => {
        if (index === action.payload[1].index) {
          return mediaData;
        }
        return item;
      });

      return {
        ...state,
        media: updatedItems,
      };
    }

    case types.REMOVE_DEMOGRAPHIC: {
      const copyOfDemographics = [...state.demographics];
      copyOfDemographics.splice(action.payload, 1);

      const copyOfProfiles = [...state.profiles];
      copyOfProfiles.splice(action.payload, 1);

      const copyOfAttitudes = [...state.attitudes];
      copyOfAttitudes.splice(action.payload, 1);

      const copyOfBrands = [...state.brands];
      copyOfBrands.splice(action.payload, 1);

      // remove profile brand section
      const copyOfprofileBrands = [...state.profileBrands];
      copyOfprofileBrands.splice(action.payload, 1);

      const copyOfprofileMedia = [...state.profileMedia];
      copyOfprofileMedia.splice(action.payload, 1);

      const copyOfMedia = [...state.media];

      copyOfMedia.splice(action.payload, 1);

      const copyOfInsight360PersonaExpression = [
        ...state.insight360PersonaExpression,
      ];
      copyOfInsight360PersonaExpression.splice(action.payload, 1);

      const copyOfinsight360PersonaExpressionID = [
        ...state.insight360PersonaExpressionID,
      ];
      copyOfinsight360PersonaExpressionID.splice(action.payload, 1);

      const copyOfinsight360ExplorerDefId = [...state.insight360ExplorerDefId];
      copyOfinsight360ExplorerDefId.splice(action.payload, 1);

      const copyOfInsight360PersonaLabel = [...state.insight360PersonaLabel];
      copyOfInsight360PersonaLabel.splice(action.payload, 1);

      const copyOfInsight360PersonaSample = [...state.insight360PersonaSample];
      copyOfInsight360PersonaSample.splice(action.payload, 1);

      const copyOfInsight360PersonaWeight = [...state.insight360PersonaWeighted];
      copyOfInsight360PersonaWeight.splice(action.payload, 1);

      const copyOfInsight360PersonaPct = [...state.insight360PersonaPct];
      copyOfInsight360PersonaPct.splice(action.payload, 1);

      const copyOfInsight360PersonaFilter = [...state.insight360PersonaFilter];

      copyOfInsight360PersonaFilter.splice(action.payload, 1);
      copyOfInsight360PersonaFilter.filterIndex = -1;

      copyOfInsight360PersonaFilter.push('');

      return {
        ...state,
        demographics: copyOfDemographics,
        attitudes: copyOfAttitudes,
        brands: copyOfBrands,
        media: copyOfMedia,
        profileBrands: copyOfprofileBrands,
        profileMedia: copyOfprofileMedia,
        insight360PersonaExpression: copyOfInsight360PersonaExpression,
        insight360PersonaExpressionID: copyOfinsight360PersonaExpressionID,
        insight360ExplorerDefId: copyOfinsight360ExplorerDefId,
        insight360PersonaLabel: copyOfInsight360PersonaLabel,
        insight360PersonaFilter: copyOfInsight360PersonaFilter,
        insight360PersonaSample: copyOfInsight360PersonaSample,
        insight360PersonaWeighted: copyOfInsight360PersonaWeight,
        insight360PersonaPct: copyOfInsight360PersonaPct,
        profiles: copyOfProfiles,
        insights360Reports: [],
        insights360ReportSortInfo: {},
      };
    }

    case types.REMOVE_PERSONA_CREATOR: {
      const attitudesList = state.personaCreator.clusterSegments.attitudesList;
      const pcWelcomePopup = state.personaCreator.pcWelcomePopup;
      const defaultExpression = _.clone(
        state.personaCreator.clusterSegments.defaultExpression,
      );
      const defaultExpressionObject = _.clone(
        state.personaCreator.clusterSegments.defaultExpressionObject,
      );
      return {
        ...state,
        personaCreator: {
          insight360AttitudeAgreeChoice: '',
          clusterSegments: {
            ...state.personaCreator.clusterSegments,
            segmentCount: 3,
            attitudesList,
            clusterStatExpressions: defaultExpression,
            selectedExpressionObject: defaultExpressionObject,
          },
          multiClusterSegments: [],
          segments: [],
          segmentsScreen: false,
          inight360VerticalPercent: VERTICAL_PERCENT_FILTER_VALUE,
          pcWelcomePopup,
          // Reset to default user preferences during reset
          selectedFilters: {
            brands: action.payload.brandFilters,
            media: action.payload.mediaFilters,
          },
          topMediaBrandSelectedFilters: {
            brands: action.payload.brandFilters,
            media: action.payload.mediaFilters,
          },
          sortByIndexAndReach: {
            media: 'index',
            brands: 'index',
            profiles: 'index',
            attitudes: 'index',
            demographics: 'index',
          },
        },
      };
    }

    case types.UPDATE_ATTITUDE_INSIGHT_AGREE_CHOICE: {
      return {
        ...state,
        insight360AttitudeAgreeChoice: action.payload,
      };
    }

    case types.UPDATE_CREATOR_ATTITUDE_INSIGHT_AGREE_CHOICE: {
      return {
        ...state,
        personaCreator: {
          ...state.personaCreator,
          insight360AttitudeAgreeChoice: action.payload,
        },
      };
    }

    case types.GET_360_REPORTS_DICTIONARY_TREE_LOAD: {
      if (action.nodeID !== 0) {
        const deepTreeCopy = treeUtils.getDeepTreeCopy(
          state.insight360ReportsDictionaryTree.data,
        );
        const data = treeUtils.updateTreeNode(
          deepTreeCopy,
          { children: action.payload.data },
          action.nodeID,
        );

        return {
          ...state,
          insight360ReportsDictionaryTree: {
            ...state.insight360ReportsDictionaryTree,
            data,
          },
        };
      }
      return {
        ...state,
        insight360ReportsDictionaryTree: action.payload,
      };
    }

    case types.SEARCH_360_REPORTS_DICTIONARY_TREE_LOAD: {
      return {
        ...state,
        insight360ReportsDictionaryTree: action.payload,
      };
    }
    case types.SHOW_INSIGHT360_PERSONAS_REPORTVIEW: {
      const reports = [];
      action.payload.data.forEach(element => {
        const report = {};
        report.label =
          element.headers !== undefined && element.headers[1] !== undefined
            ? element.headers[1].label
            : '';
        report.weighted =
          element.headers !== undefined && element.headers[1] !== undefined
            ? _.toString(element.headers[1].weighted).replace(
                /\B(?=(\d{3})+\b)/g,
                ',',
              )
            : '';
        report.reach =
          element.headers !== undefined && element.headers[1] !== undefined
            ? _.round(element.headers[1].pct, 2)
            : '';
        report.categorySelected =
          element.displayOptions !== undefined
            ? _.keys(element.displayOptions)[0]
            : INSIGHT_360_DEFAULT_DISPLAY_OPTION;
        report.displayOptions =
          element.displayOptions !== undefined
            ? _.values(element.displayOptions)[0]
            : {};
        report.detailGroups =
          element.detailGroups !== undefined
            ? _.values(element.detailGroups)[0]
            : {};
        reports.push(report);
      });
      return {
        ...state,
        insights360Reports: reports,
      };
    }
    case types.SAVE_360_DICTIONARY_SELECTED_CATEGORY: {
      return {
        ...state,
        selectedCategory: action.payload,
      };
    }
    case types.GET_360_REPORTS_DEFINITION_TREE_LOAD: {
      return {
        ...state,
        definitionTree: {
          ...action.payload,
          data:
            action.payload.status === 'SUCCESS'
              ? action.payload.data.filter(
                  definition =>
                    !(
                      (definition.scope === 1 ||
                        definition.scope === 3 ||
                        definition.scope === 5) &&
                      action.productNo !== definition.productId
                    ),
                )
              : [],
        },
      };
    }
    case types.GET_360_REPORTS_DEFINITION_TARGET_LOAD: {
      return {
        ...state,
        definitionTarget: action.payload,
      };
    }

    case types.UPDATE_PERSONA_FIXED_HEADER_CHOICE: {
      return {
        ...state,
        insight360PersonaFixedHeaderChoice: action.payload,
      };
    }
    case types.PERSONA_CREATOR_360_CLUSTER_SEGMENTS: {
      const segmentData = _.clone(action.payload.data);

      const clusterExpressionData =
        action.clusterStatExpressions.length > 0
          ? action.clusterStatExpressions
          : _.clone(
              state.personaCreator.clusterSegments.clusterStatExpressions,
            );

      const selectedExpressionObjectData =
        action.selctedExpressionObject.length > 0
          ? action.selctedExpressionObject
          : _.clone(
              state.personaCreator.clusterSegments.selectedExpressionObject,
            );
      if (segmentData.segments.length > 3) {
        segmentData.segments = [];
      }
      return {
        ...state,
        personaCreator: {
          ...state.personaCreator,
          segments: segmentData,
          multiClusterSegments: action.payload.data,
          clusterSegments: {
            ...state.personaCreator.clusterSegments,
            segmentCount: action.segmentCount,
            clusterStatExpressions: clusterExpressionData,
            selectedExpressionObject: selectedExpressionObjectData,
            selectedAttitudinalTemplate: action.selectedAttitudinal,
          },
        },
      };
    }
    case types.SAVE_PERSONA_CREATOR_HEADER_INFO:
      [];
      {
        return {
          ...state,
          personaCreator: {
            ...state.personaCreator,
            header: {
              expression: action.payload.expressions[0],
              label: action.payload.label,
              pct: action.payload.pct,
              weighted: action.payload.weighted,
              sample: action.payload.sample,
            },
          },
        };
      }
    case types.PERSONA_CREATOR_360_MULTIPLE_CLUSTER_SEGMENTS: {
      const clusterExpressionData =
        action.clusterStatExpressions.length > 0
          ? action.clusterStatExpressions
          : _.clone(
              state.personaCreator.clusterSegments.clusterStatExpressions,
            );

      const selectedExpressionObjectData =
        action.selctedExpressionObject.length > 0
          ? action.selctedExpressionObject
          : _.clone(
              state.personaCreator.clusterSegments.selectedExpressionObject,
            );
      return {
        ...state,
        personaCreator: {
          ...state.personaCreator,
          multiClusterSegments: action.payload.data,
          clusterSegments: {
            ...state.personaCreator.clusterSegments,
            segmentCount: action.segmentCount,
            clusterStatExpressions: clusterExpressionData,
            selectedExpressionObject: selectedExpressionObjectData,
          },
        },
      };
    }

    case types.SET_IS_PERSONA_CREATOR_SEGMENT_SCREEN: {
      return {
        ...state,
        personaCreator: {
          ...state.personaCreator,
          segmentsScreen: action.payload,
        },
      };
    }

    case types.UPDATE_PERSONA_CREATOR_SEGMENTS: {
      action.payload.defId =
        action.payload.defId === ''
          ? state.personaCreator.segments.defId
          : action.payload.defId;
      action.payload.defName =
        action.payload.defName === ''
          ? state.personaCreator.segments.defName
          : action.payload.defName;
      action.payload.variance =
        action.payload.variance === ''
          ? state.personaCreator.segments.variance
          : action.payload.variance;
      return {
        ...state,
        personaCreator: {
          ...state.personaCreator,
          segments: action.payload,
          media: [],
          brands: [],
          attitudes: [],
          profiles: [],
          demographics: [],
        },
      };
    }

    case types.SAVE_CREATOR_ATTITUDE_INSIGHT_DATA: {
      /* let clusterSegmentsAttitueData =
      generateObject(state.personaCreator.clusterSegments, 'attitudesList',
           action.attitudesList.finalJsondata.formatedJsondata);
      let clusterSegmentsStatExpressions =
      generateObject(clusterSegmentsAttitueData,'clusterStatExpressions',
           action.attitudesList.finalJsondata.defaultSelectedExpression);
      let clusterSegmentsdata =
      generateObject(clusterSegmentsStatExpressions,'selectedExpressionObject',
            action.attitudesList.finalJsondata.defaultSelectedObject);

      return generateObject(state, 'personaCreator',
      {...state.personaCreator,clusterSegments : clusterSegmentsdata}); */
      return {
        ...state,
        personaCreator: {
          ...state.personaCreator,
          clusterSegments: {
            ...state.personaCreator.clusterSegments,
            attitudesList: action.attitudesList.finalJsondata.formatedJsondata,
            clusterStatExpressions:
              action.attitudesList.finalJsondata.defaultSelectedExpression,
            defaultExpression:
              action.attitudesList.finalJsondata.defaultSelectedExpression,
            selectedExpressionObject:
              action.attitudesList.finalJsondata.defaultSelectedObject,
            defaultExpressionObject:
              action.attitudesList.finalJsondata.defaultSelectedObject,
            defaultAttitudinalTemplate:
              action.attitudesList.finalJsondata.formatedJsonAttitudinalData,
          },
        },
      };
    }
    case types.UPDATE_PERSONA_CREATOR_DEFINITION_NAME: {
      return {
        ...state,
        personaCreator: {
          ...state.personaCreator,
          segments: { ...state.personaCreator.segments, defName: action.data },
          header: { ...state.personaCreator.header, label: action.data },
        },
      };
    }
    case types.UPDATE_MODIFY_SEGMENT_NAME: {
      const copyPersonaCrator = _.clone(state.personaCreator);
      let multiClusterSegmentsObj;
      let segmentsObj;

      const findIndexInMultiSegment = findObjectIndexInArray(
        copyPersonaCrator.multiClusterSegments.segments,
        'expression',
        action.data.expression,
      );
      const findIndexInSegments = findObjectIndexInArray(
        copyPersonaCrator.segments.segments,
        'expression',
        action.data.expression,
      );

      if (findIndexInMultiSegment !== -1) {
        multiClusterSegmentsObj = generateObject(
          state.personaCreator.multiClusterSegments,
          'segments',
          [
            ...state.personaCreator.multiClusterSegments.segments.slice(
              0,
              findIndexInMultiSegment,
            ),
            action.data,
            ...state.personaCreator.multiClusterSegments.segments.slice(
              findIndexInMultiSegment + 1,
            ),
          ],
        );
      }

      if (findIndexInSegments !== -1) {
        segmentsObj = generateObject(
          state.personaCreator.segments,
          'segments',
          [
            ...state.personaCreator.segments.segments.slice(
              0,
              findIndexInSegments,
            ),
            action.data,
            ...state.personaCreator.segments.segments.slice(
              findIndexInSegments + 1,
            ),
          ],
        );
      }
      return generateObject(state, 'personaCreator', {
        ...state.personaCreator,
        multiClusterSegments: multiClusterSegmentsObj,
        segments: segmentsObj,
      });
    }
    case types.SAVE_BRAND_INSIGHT360_VERTICAL_PERCENT: {
      if (
        action.payload.isPersonaCreator !== undefined &&
        action.payload.isPersonaCreator
      ) {
        return {
          ...state,
          personaCreator: {
            ...state.personaCreator,
            inight360VerticalPercent: action.payload.vPct,
          },
        };
      }
      return {
        ...state,
        inight360VerticalPercent: action.payload.vPct,
      };
    }
    case types.SET_PERSONA_CREATOR_POPUP_DISPLAY: {
      return {
        ...state,
        personaCreator: {
          ...state.personaCreator,
          pcWelcomePopup: action.payload,
        },
      };
    }
    case types.SET_360_REPORTER_SORT_INFO: {
      return {
        ...state,
        insights360ReportSortInfo: {
          ...state.insights360ReportSortInfo,
          index: action.payload.index,
          type: action.payload.type,
          sortBy: action.payload.sortBy,
          view: action.payload.view,
        },
      };
    }
    case types.SET_360REPORTS_VARIABLE_SELECTION: {
      return {
        ...state,
        insight360VariableSelection: action.payload,
      };
    }
    case types.UPDATE_INSIGHT360_PERSONA_LABEL: {
      const copyOfinsight360PersonaExpressionID = [
        ...state.insight360PersonaExpressionID,
      ];
      copyOfinsight360PersonaExpressionID[action.data.indexToUpdate] =
        action.data.personaLabelID[0];

      const copyOfInsight360PersonaLabel = [...state.insight360PersonaLabel];
      copyOfInsight360PersonaLabel[action.data.indexToUpdate] =
        action.data.personaLabel[0];

      const copyOfinsight360ExplorerDefId = [...state.insight360ExplorerDefId];
      copyOfinsight360ExplorerDefId[action.data.indexToUpdate] =
        action.data.defId;

      return {
        ...state,
        insight360PersonaLabel: copyOfInsight360PersonaLabel,
        insight360PersonaExpressionID: copyOfinsight360PersonaExpressionID,
        insight360ExplorerDefId: copyOfinsight360ExplorerDefId,
      };
    }
    case types.SAVE_ATTITUDINAL_TEMPLATE_DATA: {
      const attitudinaldata = _.clone(
        state.personaCreator.clusterSegments.defaultAttitudinalTemplate,
      );
      attitudinaldata.push(action.data);
      return {
        ...state,
        personaCreator: {
          ...state.personaCreator,
          clusterSegments: {
            ...state.personaCreator.clusterSegments,
            defaultAttitudinalTemplate: attitudinaldata,
          },
        },
      };
    }
    case types.SAVE_360_SELECTED_FILTERS: {
      if (action.payload.tabInfo === INSIGHT360_EXPLORE) {
        return {
          ...state,
          selectedFilters: {
            ...state.selectedFilters,
            [action.payload.category]: action.payload.data,
          },
        };
      } if (action.payload.tabInfo === INSIGHT360_PERSONA_CREATOR) {
        return {
          ...state,
          personaCreator: {
            ...state.personaCreator,
            selectedFilters: {
              ...state.personaCreator.selectedFilters,
              [action.payload.category]: action.payload.data,
            },
          },
        };
      }
      return state;
    }

    case types.SHOW_BC_CONFIG_SCREEN: {
      return {
        ...state,
        bcConfiguration: { ...state.bcConfiguration,
          bcConfigPopupShow: action.payload,
        },
      };
    }

    case types.SET_SECTION_SORT_KEY: {
      if (action.payload.reportName === '360PROF') {
        if (action.payload.isPersonaCreator !== true) {
          return {
            ...state,
            sortByIndexAndReach: {
              ...state.sortByIndexAndReach,
              profiles: action.payload.sortByKey,
            },
          };
        } return {
          ...state,
          personaCreator: {
            ...state.personaCreator,
            sortByIndexAndReach: {
              ...state.personaCreator.sortByIndexAndReach,
              profiles: action.payload.sortByKey,
            },
          },
        };
      }
      // / Att..
      if (action.payload.reportName === '360ATT') {
        if (action.payload.isPersonaCreator !== true) {
          return {
            ...state,
            sortByIndexAndReach: {
              ...state.sortByIndexAndReach,
              attitudes: action.payload.sortByKey,
            },
          };
        } return {
          ...state,
          personaCreator: {
            ...state.personaCreator,
            sortByIndexAndReach: {
              ...state.personaCreator.sortByIndexAndReach,
              attitudes: action.payload.sortByKey,
            },
          },
        };
      }
      // Brands sorts..
      if (action.payload.reportName === '360BRANDS') {
        if (action.payload.isPersonaCreator !== true) {
          return {
            ...state,
            sortByIndexAndReach: {
              ...state.sortByIndexAndReach,
              brands: action.payload.sortByKey,
            },
          };
        } return {
          ...state,
          personaCreator: {
            ...state.personaCreator,
            sortByIndexAndReach: {
              ...state.personaCreator.sortByIndexAndReach,
              brands: action.payload.sortByKey,
            },
          },
        };
      }
          // media sorts..
      if (action.payload.reportName === '360MEDIA') {
        if (action.payload.isPersonaCreator !== true) {
          return {
            ...state,
            sortByIndexAndReach: {
              ...state.sortByIndexAndReach,
              media: action.payload.sortByKey,
            },
          };
        } return {
          ...state,
          personaCreator: {
            ...state.personaCreator,
            sortByIndexAndReach: {
              ...state.personaCreator.sortByIndexAndReach,
              media: action.payload.sortByKey,
            },
          },
        };
      }
          // demo section sorting..
      if (action.payload.reportName === '360DEMOS') {
        if (action.payload.isPersonaCreator !== true) {
          return {
            ...state,
            sortByIndexAndReach: {
              ...state.sortByIndexAndReach,
              demographics: action.payload.sortByKey,
            },
          };
        } return {
          ...state,
          personaCreator: {
            ...state.personaCreator,
            sortByIndexAndReach: {
              ...state.personaCreator.sortByIndexAndReach,
              demographics: action.payload.sortByKey,
            },
          },
        };
      }
    }

    case types.SHOW_DEEP_DIVE_POPUP: {
      return {
        ...state,
        deepDivePopupShow: action.value,
        deepDiveDetails: (!action.value) ? {} : action.deepDiveDetails,
      };
    }
    case types.SET_BRAND_CATALYST_PREFERENCE_DATA : {
      return generateObject(state, undefined, action.data);
    }
    default:
      return state;
  }
}

